export default "__VITE_ASSET__BRulciiq__"